
export const boolFormatter = function (value, key, item) {
  return value ? 'Tak' : 'Nie'
}



// WEBPACK FOOTER //
// ./src/utils/formatters.js